import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTickets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.112 7.027a2.05 2.05 0 0 1 2.123.493 2 2 0 0 1 0 2.825l-6.611 6.62a1.993 1.993 0 0 1-2.822 0 2.06 2.06 0 0 1-.492-2.126 1.135 1.135 0 0 0-1.449-1.45 2.05 2.05 0 0 1-2.123-.494 2 2 0 0 1 0-2.825l2.031-2.034h.001l4.58-4.586a2.02 2.02 0 0 1 3.313 2.126 1.136 1.136 0 0 0 1.45 1.451ZM7.18 9.39a.75.75 0 0 1 1.06 0l1.25 1.249a.75.75 0 0 1-1.061 1.06L7.18 10.45a.75.75 0 0 1 0-1.061Zm3.893 2.896a.75.75 0 1 0-1.067 1.053l.296.301a.75.75 0 0 0 1.068-1.053l-.296-.3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTickets;
